import { getSvgIconName, GridCol, SvgIcon } from '@bob/library'
import { AppProviderContext } from '@websrc/App/AppContext'
import { matomo } from '@websrc/App/Tracking/Matomo'
import { mapCardSection } from '@websrc/DataMappers/mapSpot'
import clsx from 'clsx'
import { hoverShadow, styles } from 'leds'
import React, { FC, useContext } from 'react'

import { Asset } from '../Asset/Asset'
import { CTA } from '../CTA'
import Heading from '../Heading/Heading'
import { card, cardSection } from './CardSection.css'

export interface CardSectionProps {
  rows: ReturnType<typeof mapCardSection>['rows']
  isTopOfPage?: boolean
}

export const CardSection: FC<CardSectionProps> = ({ rows, isTopOfPage }) => {
  const { matomoPageTemplate } = useContext(AppProviderContext)
  return (
    <div className={cardSection._}>
      <GridCol>
        {rows.map(({ items }, i) => {
          const variant =
            items.length > 0 && items.length < 5
              ? (`v${items.length}` as 'v1' | 'v2' | 'v3' | 'v4')
              : 'v4'
          return (
            <div className={cardSection.row._[variant]} key={i}>
              {items.map(({ body_text, headline, icon, image, link, pill_label, image_fit }) => (
                <div className={cardSection.row.item} key={headline}>
                  <div className={clsx(card._, hoverShadow)}>
                    <div className={card.contentWrapper}>
                      {image && (
                        <div className={card.imageWrapper}>
                          <Asset
                            className={styles({ width: 'full' })}
                            objectFit={
                              image_fit ? (image_fit as 'cover' | 'contain' | undefined) : 'cover'
                            }
                            thumbnail={image}
                          />
                        </div>
                      )}
                      <div className={card.content}>
                        {pill_label && (
                          <div className={card.pillContainer}>
                            <span className={card.pill}>{pill_label}</span>
                          </div>
                        )}
                        {icon.icon && (
                          <SvgIcon
                            name={getSvgIconName(icon.icon)}
                            size={32}
                            title={icon.label ?? ''}
                          />
                        )}
                        <div>
                          <Heading
                            description={body_text}
                            headline={headline}
                            level={isTopOfPage ? 2 : 3}
                            size={'s'}
                          />
                        </div>
                      </div>
                      <CTA className={card.ctaCard} cta={link} noText={true} />
                    </div>
                    {link?.text && (
                      <div className={card.ctaWrapper}>
                        <CTA
                          className={card.cta}
                          colorTheme={'blueInverse'}
                          cta={link}
                          fontSize={'md'}
                          fontWeight={'bold'}
                          onClick={() => {
                            matomo.trackEvent(
                              'engagement',
                              matomoPageTemplate,
                              ['card list'],
                              [headline],
                              'card'
                            )
                          }}
                          type={'tertiary'}
                          withDefaultPrefix={true}
                        />
                      </div>
                    )}
                  </div>
                </div>
              ))}
            </div>
          )
        })}
      </GridCol>
    </div>
  )
}
